<template>
  <div class="comp-fh-board" ref="containerRef" @scroll="handleScroll">
    <!-- 占位元素撑满滚动区域 -->
    <div class="board-gr-spacer" :style="{ height: totalHeight + 'px' }"></div>
    <!-- 可见内容区域 -->
    <div class="board-gr-content" :style="{ maxHeight: height - 55 + 'px', transform: `translateY(${offsetY}px)` }">
      <div v-for="(item, index) in visibleItems" :key="item.id" class="board-gr-item" :ref="(el) => setItemRef(startIndex + index, el)" @click.stop="handleClick(item)">
        <template v-if="item.hasData">
          <fh-board-item :columns="columns" :viewId="viewId" :rowItem="item" :businessData="businessData" :shortcutBtnPermission="shortcutBtnPermission" :entityId="entityId" @getComputedStatus="getComputedStatus" @shortcutBtnCb="shortcutBtnCb"></fh-board-item>
        </template>
        <template v-else>
          <fh-list-skeleton :rows="8" :columns="1" />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import FhBoardItem from '@/components/fh-list/fh-board-view/components/fh-board-item/fh-board-item.vue';
import FhListSkeleton from '@/components/fh-list/fh-list-skeleton/fh-list-skeleton.vue';
import useVirtualCardList from '@/hooks/virtual-card-list';
const props = defineProps({
  columns: {
    type: Array,
    default: () => []
  },
  // 实体ID
  entityId: {
    type: Number,
    default: 0
  },
  // 视图ID
  viewId: {
    type: String,
    default: ''
  },
  // 数据
  records: {
    type: Array,
    default: () => []
  },
  // 高度
  height: {
    type: Number,
    default: 0
  },
  // 缓冲区数量
  bufferCount: {
    type: Number,
    default: 4
  },
  // 快捷按钮权限
  shortcutBtnPermission: {
    type: Object,
    default: () => ({})
  },
  // 是否隐藏看板label 1.隐藏 0.展示
  businessData: {
    type: String,
    default: '0'
  }
});

const emit = defineEmits(['itemHeightChange', 'scrollBottom', 'toDetails', 'getComputedStatus', 'shortcutBtnCb']);

// 快捷按钮回调
const shortcutBtnCb = (params, type) => {
  emit('shortcutBtnCb', params, type);
};

// 获取计算后的状态
const getComputedStatus = (item) => {
  emit('getComputedStatus', item);
};

// 打开详情
const handleClick = (item) => {
  emit('toDetails', item);
};

// 使用虚拟列表 Hook
const { containerRef, totalHeight, startIndex, visibleItems, offsetY, setItemRef, handleScroll } = useVirtualCardList(props, emit);
</script>

<style scoped lang="less">
@import './fh-board-card.less';
</style>
